import 'what-input';
import './polyfill';
import hashScroll from './hashScroll';
import changeMetaViewport from './changeMetaViewport';

hashScroll();
changeMetaViewport();
